<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Billing</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row justify="center" class="text--primary subtitle-1">
          <v-col cols="12" md="10">
            <v-row class="mb-3">
              <v-col cols="12" md="7">
                <h3>E-Wallet Top Up</h3>

                <div class="mt-2">1. Go to M-PESA on your phone</div>
                <div class="mt-2">2. Select Lipa Na M-PESA -> Pay Bill</div>
                <div class="mt-2">3. Enter Business No: <b>4097183</b></div>
                <div class="mt-2">
                  4. Enter Account No: <b>{{ CardCode }}</b>
                </div>
                <div class="mt-2">5. Enter the amount you want to top up</div>
                <div class="mt-2">6. Enter your M-PESA PIN and send</div>
                <div class="mt-2">
                  7. You will receive Confirmation sms from M-PESA
                </div>
              </v-col>
              <v-col
                cols="12"
                md="5"
                style="border-left: 2px solid gray !important"
              >
                <h3>E-Wallet Status</h3>

                <div class="mt-2">
                  Account Balance<br />
                  <b>{{ eWalletBalance }}</b>
                </div>

                <div>
                  Sms Balance<br />
                  <b>{{ SmsBalance }}</b>
                </div>

                <div class="mt-2">
                  <v-btn color="accent" @click.native="smsDialog = true"
                    >Buy Sms</v-btn
                  >
                </div>
              </v-col>
            </v-row>

            <v-divider></v-divider>

            <v-row>
              <!-- history -->
              <v-col cols="12" class="mt-2">
                <h4>Payments History</h4>
                <v-data-table
                  :items-per-page="50"
                  :headers="headers"
                  :items="mpesas"
                  :mobile-breakpoint="0"
                >
                </v-data-table>
              </v-col>
              <!-- end -->
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Account quick add dialog -->
    <v-dialog v-model="smsDialog" max-width="450px">
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title>Buy Sms Here</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="smsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  outlined
                  dense
                  label="Amount To Spend"
                  v-model="smsAmount"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-btn color="accent" :loading="loader" @click="buySms"
                  >Buy Now</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of modal-->

    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      smsDialog: false,
      eWalletBalance: null,
      SmsBalance: null,
      CardCode: null,
      smsAmount: null,
      loader: false,
      mpesas: [],
      headers: [
        { text: "Payment Mode", value: "TransactionType" },
        { text: "Pay Bill", value: "BusinessShortCode" },
        { text: "Account", value: "BillRefNumber" },
        { text: "Amount", value: "TransAmount" },
        { text: "Ref Code", value: "TransID" },
        { text: "Date", value: "created_at" },
      ],
    };
  },
  methods: {
    buySms() {
      const amount = this.smsAmount;
      const data = { amount: amount };
      const self = this;
      const url = "/buy-sms";
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            location.reload();
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGenSettings() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.eWalletBalance = res.ResponseData.EWalletBalance;
            self.SmsBalance = res.ResponseData.SmsBalance;
            self.CardCode = res.ResponseData.CardCode;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getMpesas() {
      const self = this;
      this.$store
        .dispatch("get", `/mpesa-payments-history`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.mpesas = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getGenSettings();
    this.getMpesas();
  },
};
</script>

<style lang="scss" scoped>
</style>